// extracted by mini-css-extract-plugin
export default {"productDescription":"a_-z","featuredDescription":"b_-z","description":"c_-z","more":"d_-z","descriptionSku":"e_-z"};